import React, { forwardRef, useCallback, useMemo, useState } from "react";
import { FieldTypes, urlRegexValidator } from "utils/formUtils";
import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import CortexMappingForm from "./CortexMappingForm";
import { Alert } from "antd";
import { useFeatureFlag } from "contexts/FeatureFlagContext";

function CortexCredentialsForm(props, ref) {
    const [apiKey, setAPIKey] = useState();
    const featureFlags = useFeatureFlag();
    
    const fields = useMemo(() => ([
        {
            name: "apiEndpoint",
            label: "API Endpoint",
            required: true,
            rules: [urlRegexValidator],
        },
        {
            name: "apiKey",
            label: "Api Key",
            type: FieldTypes.PASSWORD,
            required: true,
            props: {
                onChange: (e) => setAPIKey(e.target.value) 
            }
        },
        {
            name: "apiKeyId",
            label: "Api Key ID",
            type: FieldTypes.PASSWORD,
            required: true,
        },
        ...(featureFlags.RBVM_ASSETS ? [{
            name: "fetchAssets",
            label: "Fetch Assets",
            type: FieldTypes.BOOLEAN,
            disabled: !apiKey,
            inline: true,
        }] : []),
        {
            render: () => <Alert type='warning' description={"Cortex XDR integration relies on Compute Units to successfully fetch findings. Consumption of Compute Units varies depending on the volume of findings present in the Cortex XDR tenant and mapping criteria specified in ArmorCode. Please review the Compute Units Usage section in Cortex XDR for more details."}/>
        }
        ]),
        [featureFlags.RBVM_ASSETS, apiKey]
    );

    const parseExtraFields = useCallback((config) => {
        return {
            ...config,
            fetchAssets: config.fetchAssets === "true"
        }
    }, [])

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={CortexMappingForm}
            parseExtraFields={parseExtraFields}
        />
    )
}

export default forwardRef(CortexCredentialsForm);